import ManuelBarcodeInput from './ManuelBarcodeInput';

export * from './ManuelBarcodeInput';

export default ManuelBarcodeInput;
